import { Col, Row, Modal, message, Alert } from 'antd';
import React, { useState, useEffect, useContext, useMemo } from 'react'
import { Input, Select, Button, Form } from 'antd';
import commonLib from '../../control/commonLib';
import konsole from '../../network/konsole';
import Services from '../../network/Services';
import "./CommunicationModal/communicationmodal.css";
import { UserContext } from "../../App.js";
import { ModalBody } from 'react-bootstrap';
import { useRef } from 'react';
import AtTheRateTextArea from './AtTheRateTextArea.js';
import { isNullUndefine } from '../../control/Constant.js';

export const ViewandupdateNewModal = (props) => {
    const [initialcommchannelid, setinitialcommchannelid] = useState(null)
    const [form] = Form.useForm();
    const { setLoader } = useContext(UserContext)
    const [getChannelValue, setChannelValue] = useState()
    const [getSelectRoleToValue, setSelectRoleToValue] = useState()
    const [isDisabled, setISDisabled] = useState(true)
    const [getUserRoleSelect, setUserRoleSelect] = useState([])
    const [RoleFromLength, setRoleFromLength] = useState(0)
    const [RoleToLength, setRoleToLength] = useState(0)
    const [fromRoleIdd, setfromRoleId] = useState(0)
    const [toRoleId, settoRoleId] = useState(0)
    const [isTrueValue, setIsTrueValue] = useState(false)
    const [isStopApi, setISStopApi] = useState(false)
    const [subtenantID, setSubtenantID] = useState()
    const [isUpdate, setISUpdate] = useState(false)
    const [selectedChannelID, setSelectedChannelID] = useState(4)
    const [ckeditorID, setCkEditorID] = useState(4)
    const [selectedFromID, setSelectedFromID] = useState(2)
    const [selectedToID, setSelectedToID] = useState(2)
    const [channelEmailLabel, setChannelEmailLabel] = useState([])
    const [channelTextLabel, setChannelTextLabel] = useState([])
    const [channeBothLabel, setChanneBothLabel] = useState([])
    let userId = commonLib.getObjFromStorage("stateObj").userId
    const [screenId, setScreenId] = useState(0);
    const [textMessage, setTextMessage] = useState()




    useEffect(() => {

        let subtenantID = commonLib.getSessionStoarge("subtenantId")
        setSubtenantID(subtenantID);
    }, [props?.selectedRowData?.applicableEmailTempId, props?.selectedRowData?.applicableTextTempId])


    useEffect(() => {
       form.setFieldsValue({
            "screenName": props?.selectedRowData?.screenName,
            "moduleSubSection": props?.selectedRowData?.moduleSubSection,
            "moduleSectionName": props?.selectedRowData?.moduleSectionName,
        })
        setTextMessage(props?.selectedRowData?.comMediumContent?.displayContent)
        setScreenId(props?.selectedRowData?.screenId)
    }, [props?.selectedRowData?.screenName, props?.selectedRowData?.moduleSubSection,props?.selectedRowData?.moduleSectionName])
    const [channelIdData, setChannelIdData] = useState()


    useEffect(() => {
    setChannelIdData(props?.selectedRowData?.commChannelId)

        let valuedata =
            (props?.selectedRowData?.commChannelId) === 1 ? channelEmailLabel
                : (props?.selectedRowData?.commChannelId) === 2 ? channelTextLabel
                    : props?.selectedRowData?.commChannelId === 3 ? channeBothLabel : ""
        setinitialcommchannelid(props?.selectedRowData?.commChannelId)
        form.setFieldsValue({
            "commChannel": valuedata ? valuedata : getChannelValue?.value,
        })

    }, [props?.selectedRowData?.commChannelId, channelEmailLabel, channelTextLabel, channeBothLabel])


    const handleClose = () => {
         let subtenantIDd = commonLib.getSessionStoarge("subtenantId")
        setChannelValue("")
        setSelectRoleToValue("")
        setSelectedChannelID(4)
        setISUpdate(false)
        setISDisabled(true)
        props.setShowAddModal(false);
        props.GetCommMediumPathApiFuction(subtenantIDd)

    }
    let linkButton = document.getElementById("createLink");





    const handleFromRoleChange = (value, key) => {
        setRoleFromLength(0)
        setfromRoleId(0)
        setIsTrueValue(false)
        setISStopApi(true)


        if (getSelectRoleToValue?.length > 0) {
            setSelectedFromID(2)
            setSelectedToID(2)

        }

        else {
            setSelectedToID(1)

        }

    };

    const handleToRoleChange = (value, key) => {
        setSelectRoleToValue(key)
        setRoleToLength(0)
        settoRoleId(0)
        setISStopApi(true)
    }


        const handleTextUpdate = (e) => {
        form.setFieldsValue(
            {
                hellotext: e.target.value
            }
        )
    }



    const updateRecordFunction = (data) => {
        if (isNullUndefine(form.getFieldValue()?.hellotext)) {
            message.error('Please enter your content')
            setLoader(false)
            return
        }
                const jsonObject = {
                    "displayContentId": props?.selectedRowData?.comMediumContent?.applicableConId,
                    "displayContent": form.getFieldValue()?.hellotext || '',
                    "isActive": true,
                    "upsertedBy": userId,
                    "commMediumId" : props?.selectedRowData?.commMediumId
                }
                const promises = Services.upsertDisplayContentPathApi(jsonObject)
                promises.then((response) => {
                    message.success('Content Updated Successfully')
                    handleClose()
                     setLoader(false)
                }).catch((error) => {
                     setLoader(false)
                }).finally(() => {
                    konsole.log("finish");
                });
    }



    const onFinish = (e) => {

        if (isUpdate == true) {

            setLoader(true)
            setISStopApi(true)
            updateRecordFunction()

        }
        else {
            if (isStopApi == true) {
            }
            setISUpdate(true)
            setISDisabled(false)
        }
    }






    return (
        <div>

            <Modal
                centered={true}
                className="Modal-Main-Class"
                // title={<div className='d-flex justify-content-start'>{isUpdate == true ? "Update Event Template" : "View Event Template"} </div>}
                visible={props?.showAddModal}
                footer={false}
                onCancel={handleClose}
                // closeIcon={<div className='text-light' style={{ fontFamily: "sans-serif", fontWeight: 100 }}> X</div>}
                maskClosable={false}
                enforceFocus={false}
                closable={false}
                width={1000}
                style={{ top: 20 }}
                bodyStyle={{ padding: '0px', borderRadius: '8px' }}>

                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 8px 12px 8px', borderBottom: '1px solid #bfbfbf' }}>
                    <p style={{ fontSize: '16px', fontWeight: '700', color: '#333333', margin: 0 }}>
                        {isUpdate == true ? "Update Event Template" : "View Event Template"}
                    </p>
                    <span onClick={handleClose} style={{ cursor: 'pointer', fontSize: '25px', color: '#333333', lineHeight: 1, padding: '2px 6px' }}>×</span>
                </div>
                <Form form={form} onFinish={onFinish} style={{padding:"14px"}}>
                    <Row className='d-flex justify-content-between'>
                        <Col span={11} xs={24} sm={24} md={11} lg={11}>
                           <h6 style={{ marginLeft: "1px" }}>Module</h6>
                            <Form.Item
                                name="moduleSectionName"
                                rules={[
                                    {
                                        required: true,
                                        message: "Please Select Screen Name"
                                    }
                                ]}
                                className="asignRoleTo-col m-0 pb-2"

                            >
                                <Select
                                    showSearch
                                    listHeight={100}
                                    style={{ width: "100%" }}
                                    className='commChannelSelect'
                                    // mode="multiple"
                                    maxTagCount={'responsive'}
                                    showArrow
                                    onChange={handleFromRoleChange}
                                    placeholder="Select a Screen Name"
                                    disabled={true}
                                >
                                    {
                                        getUserRoleSelect.map((userdata) => (
                                            <option value={userdata?.label} key={userdata?.value}>{userdata?.label}</option>

                                        ))
                                    }
                                </Select>
                            </Form.Item>
                        </Col>

                         <Col span={11} xs={24} sm={24} md={11} lg={11} className="asignRoleTo-col m-0 p-0">
                            <h6 style={{ marginLeft: "1px" }}>Sub Module</h6>
                            <Form.Item
                                name="moduleSubSection"
                                rules={[
                                    {
                                        required: true,
                                        message: "Please select Sub Screen Name"
                                    }
                                ]}
                                className="asignRoleTo-col m-0 pb-3"
                            >
                                <Select
                                    showSearch
                                    style={{ width: "100%" }}
                                    className='commChannelSelect'
                                    listHeight={100}
                                    maxTagCount={'responsive'}
                                    // mode="multiple"
                                    showArrow
                                    onChange={handleToRoleChange}
                                    placeholder="Select a Sub Screen Name"
                                    disabled={true}

                                >
                                    {
                                        getUserRoleSelect.map((userdata) => (
                                            <option value={userdata?.label} key={userdata?.value}>{userdata?.label}</option>


                                        ))
                                    }
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row className='d-flex justify-content-between'>


                      <Col span={11} xs={24} sm={24} md={11} lg={11}>
                            <h6 style={{ marginLeft: "1px" }}>Screen Name</h6>
                            <Form.Item
                                name="screenName"
                                rules={[
                                    {
                                        required: true,
                                        message: "Please select Trigger/Event"
                                    }
                                ]}>
                                <Select
                                    className='SeminarRegistrationSelect'
                                    disabled
                                    showArrow={false}
                                >

                                </Select>
                            </Form.Item>

                        </Col>

                    </Row>
                    <Row className='justify-content-end'>
                        <Col span={24} lg={4} className="m-0 p-0 d-flex justify-content-end" >
                            <Form.Item>
                                <Button
                                    className="Add-Edit-btton text-white"
                                    htmlType="submit"
                                    type='primary'
                                    style={{ backgroundColor: "#720c20" }}
                                >
                                    {isUpdate == true ? "Update" : "Edit"}
                                </Button>
                            </Form.Item>


                        </Col>
                     </Row>


                    <ModalBody  className='Modal-Body-Add-Modal' style={{maxHeight: 'calc(100vh - 116px)', overflowY: 'auto',height: "auto"}}>


                        <Row style={{ marginRight: "5px" }} >
                            <Col span={24}>
                                {props?.selectedRowData?.comMediumContent?.displayContent ?
                                    <div>
                                         <Row >
                                            <Col span={24}>
                                                <Row className='d-flex justify-content-between'>

                                                    <Col className='' span={24} xs={24} sm={24} md={24} lg={24}>
                                                        <h6>Content</h6>

                                                        <div className='mt-2 w-100'>

                                                            <AtTheRateTextArea id="hellotext" className="w-100" rows="4" handleTextUpdate={handleTextUpdate} defaultText={textMessage} placeholder="" screenId={screenId} isDisabled={isDisabled} />
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </div>

                                    :  ""

                                 }
                            </Col>
                        </Row>
                    </ModalBody>
                </Form>


            </Modal>
        </div>
    )
}
